import styled from 'styled-components';
import Link from 'gatsby-link';
import { siteAccent } from '../styledComponents/variables/colors';

export default styled(Link)`
  font-size: 0.95rem;
  padding: 0.6rem 0.4rem;
  border: 5px solid ${siteAccent};
  @media (max-width: 700px) {
    font-size: 0.7rem;
    border: 3px solid ${siteAccent};
  }
  align-self: flex-end;
  text-decoration: none;
  display: inline-block;
  margin-bottom: 1rem;
  /* font-weight: bold; */
  color: ${siteAccent};
  box-shadow: 0px 5px 5px -1px rgba(0, 0, 0, 0.5);
  &:hover {
    background-color: ${siteAccent};
    color: white;
    box-shadow: 0px 8px 10px -1px rgba(0, 0, 0, 0.5);
  }
  transition: 0.2s;
`;



// WEBPACK FOOTER //
// ./src/components/PostLink/Button.js